import type { FaireBrandEntity } from "../../entity_types/brand";

export const defaultBrand: FaireBrandEntity = {
  token: "default",
  type: "brand",
  name: "Default Brand",
  minimumOrderDollars: 0,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
